import createIcon from '../../createIcon';

/**
 * @component @name AutoAwesomeMosaic
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA1VjE5QzMgMjAuMSAzLjg5IDIxIDUgMjFIMTFWM0g1QzMuODkgMyAzIDMuOSAzIDVaTTE5IDNIMTNWMTFIMjFWNUMyMSAzLjkgMjAuMSAzIDE5IDNaTTEzIDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVYxM0gxM1YyMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AutoAwesomeMosaic = createIcon('AutoAwesomeMosaic', [
  [
    'path',
    {
      d: 'M3 5V19C3 20.1 3.89 21 5 21H11V3H5C3.89 3 3 3.9 3 5ZM19 3H13V11H21V5C21 3.9 20.1 3 19 3ZM13 21H19C20.1 21 21 20.1 21 19V13H13V21Z',
      key: 'uxuyse',
    },
  ],
]);

export default AutoAwesomeMosaic;
